<!-- 弹窗组件 -->
<template>
  <div class="toast-box" v-if="isModal" :class="[toastClass]">
    <div class="toast-content" ref="modal" :style="{width: width+'px',height: height+'px'}">
      <div class="toast-header">
        <div class="title">
          <!-- 传过来的头部 -->
          <slot name="title"></slot>
        </div>
        <div class="close" @click="btnCancel">
          <img class="close-img" src="../../assets/img/personInfo/close@2x.png" alt />
        </div>
      </div>
      <!-- 传过来的内容 -->
      <div class="content">
        <slot name="content"></slot>
      </div>
      <div class="toast-btn" v-if="isBtn">
        <span class="btn-cancel btn" @click="btnCancel">取消</span>
        <span class="btn-submit btn" @click="btnSubmit">确定</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    // 是否显示tanchang
    isModal: {
      type: Boolean,
      default: false
    },
    // 宽是多少
    width: {
      type: Number,
      default: 400
    },
    // 高是多少
    height: {
      type: Number,
      default: 400
    },
    // 是否显示底部按钮
    isBtn: {
      type: Boolean,
      default: true
    },
    // ..自定义样式
    toastClass: {
      type: String,
      default: ''
    }
  },
  components: {},

  computed: {},

  created() {},

  mounted() {
    this.init();
  },

  methods: {
    init() {
      // this.$refs.modal.style.height = this.height+'px';
    },
    btnSubmit() {
      this.$emit("btnSubmit", {});
    },
    btnCancel() {
      this.$emit("btnCancel", {});
    }
  }
};
</script>
<style scoped lang="less">
.toast-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.5);
}
.toast-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 400px;
  height: 400px;
  margin: auto;
  background: #fff;
  // border-radius: 4px;
  .content {
    padding: 20px;
  }
  .toast-header {
    height: 50px;
    line-height: 50px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    .title {
      padding-left: 20px;
    }
    .close {
      padding: 18px 18px 0 0;
      cursor: pointer;
      line-height: 20px;
      .close-img {
        width: 14px;
        height: 14px;
      }
    }
  }
}
.toast-btn {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.toast-btn .btn {
  font-size: 16px;
  text-align: center;
  display: inline-block;
  cursor: pointer;
  line-height: 40px;
  width: 100px;
  border-radius: 2px;
  height: 40px;
}
.toast-btn .btn-submit {
  color: #fff;
  background: #3b87ff;
  border: 1px solid #3b87ff;
}
.toast-btn .btn-cancel {
  color: #333333;
  background: rgba(249, 249, 249, 1);
  border: 1px solid #eee;
  margin-right: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/Modal/Modal.vue